import { faCalculator, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import ServiceAccountings from "./ServiceAccountings";

export default function ModalServiceAccounting(props)
{
    const {serviceInfo, setServiceInfo, checkedIn, popData, setPopData} = props;
    return(
        <Modal show={popData?.show} onHide={()=>{}}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCalculator} size="lg"/>&nbsp;
                    حسابداری سرویس
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={()=>setPopData({show:false})}/>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
            <ServiceAccountings serviceInfo={serviceInfo} setServiceInfo={setServiceInfo} checkedIn={checkedIn} fromModal={true}/>
            </Modal.Body>
        </Modal>
    )
}